<ng-container *ngIf="!carregando">
  <div class='row' *ngIf="dentroDoOrcamento">
    <div class="col">
      <h5 class="subtitle"><i class="fas fa-plane"></i>{{"Aéreo" | translate}}<span class="badge badge-primary ms-3"
          *ngIf='aereo.PacoteReservaId != null'>Pacote</span></h5>
    </div>
    <div class='col flex as-fe'>
      <div class="col d-flex align-items-center text-center column-gap-3" [ngSwitch]="aereo.Status">
        <h6 class="m-0 p-0">{{ "Status: " | translate}}</h6>
        <span *ngSwitchCase="0" class="badge rounded-pill bg-secondary">{{"Pendente" | translate}}</span>
        <span *ngSwitchCase="1" class="badge rounded-pill bg-secondary">{{"Aguardando" | translate}}</span>
        <span *ngSwitchCase="2" class="badge rounded-pill bg-secondary">{{"Reserva Parcial" |
          translate}}</span>
        <span *ngSwitchCase="3" class="badge rounded-pill bg-success">{{"Reservado" | translate}}</span>
        <span *ngSwitchCase="4" class="badge rounded-pill bg-success">{{"Solicitado" | translate}}</span>
        <span *ngSwitchCase="5" class="badge rounded-pill bg-success">{{"Emitido" | translate}}</span>
        <span *ngSwitchCase="6" class="badge rounded-pill bg-success">{{"Pago" | translate}}</span>
        <span *ngSwitchCase="7" class="badge rounded-pill bg-warning text-dark">{{"Problema Técnico" |
          translate}}</span>
        <span *ngSwitchCase="8" class="badge rounded-pill bg-warning text-dark">{{"Cancelado" |
          translate}}</span>
        <span *ngSwitchCase="9" class="badge rounded-pill bg-warning text-dark">{{"Excluído" |
          translate}}</span>
        <span *ngSwitchCase="10" class="badge rounded-pill bg-warning text-dark">
          {{"Cancelamento com Problema" | translate}}</span>
      </div>
    </div>

    <div class='col flex text-center' *ngIf="aereo.LocalizadorAereo">
      <h6>{{"Localizador" | translate}}: </h6>
      <p> <span class="badge rounded-pill bg-danger">{{aereo.LocalizadorAereo}} </span></p>
    </div>

    <div class='col text-end as-fe' *ngIf="!cardSimplificado">
      <button *ngIf="aereo.Status == 0 || aereo.Status == 8" class="btn btn-outline-danger"
        (click)="confirmarRemoverAereo(aereo)">{{"Excluir" | translate }}</button>

      <button class="btn btn-outline-danger" *ngIf="aereo.Status == 3 && statusOrcamento != 6"
        (click)="modalCancelarAereo.open()">{{"Cancelar" | translate }}</button>

      <button class="btn btn-success"
        *ngIf="aereo.Status == 0 && aereo.PaxesTarifa?.length > 0 && (aereo?.Erros?.length == 0 || aereo?.Erros == null)"
        (click)="validaSePodeReservar()">{{"Reservar" | translate}}</button>

      <button class="btn btn-success" *ngIf="aereo.Status == 3 && (aereo?.Erros?.length == 0 || aereo?.Erros == null)"
        (click)="modalEmitirAereo.open()" [disabled]="statusOrcamento!=6"
        title="{{(statusOrcamento == 6 ? 'Emitir Bilhete' : 'Necessário pagar o orçamento para emitir') | translate}}">{{"Emitir"
        | translate}}</button>

      <button class="btn btn-success" *ngIf="aereo.Status == 5 && statusOrcamento==6"
        (click)="imprimirVoucherEmitter.emit(aereo)" [disabled]="!LiberarVoucher">
        <span *ngIf="!LiberarVoucher" class="fas fa-exclamation-circle"></span>
        <span *ngIf="LiberarVoucher" class="fas fa-check-circle"></span>
        {{LiberarVoucher ? 'Voucher' : 'Voucher Pendente'}}
      </button>
    </div>

  </div>

  <div class='aereo-card' [ngClass]="{'disableDiv' : aereo.Status == 8 }">
    <div class="row" *ngIf="aereo?.Seguimentos?.length > 0">
      <div class='col' *ngFor="let seguimento of aereo?.Seguimentos; let i = index">
        <div class="row">
          <div class="col ida" *ngIf="i % 2 == 0">
            <div class="row jc-sb">
              <div class="col subtitle">
                <h6><i class="fas fa-plane-departure"></i>{{"Ida" | translate}}</h6>
              </div>
            </div>
            <div *ngFor="let voo of seguimento.Voos; let k = index">
              <div class="row jc-se">
                <div class="col as-c">
                  <img src="assets/img/cias/{{ voo.CiaMarketing }}.png" alt="{{ voo.CiaMarketing}}"
                    title="{{ voo.CiaMarketing }}" />
                </div>
                <div class="col text-end">
                  <p *ngIf="k == 0 || (k > 0 && voo.AeroportoPartida == seguimento.Voos[k - 1].AeroportoChegada)">{{
                    voo.AeroportoPartida }}</p>
                  <p *ngIf="k > 0 && voo.AeroportoPartida != seguimento.Voos[k - 1].AeroportoChegada" style="color:red">
                    {{
                    voo.AeroportoPartida }}*</p>
                  <h6>{{ voo.DataPartida | date : 'dd/MM/yyyy HH:mm'}}</h6>
                </div>
                <div class="col text-center">
                  <div class="col voo-detalhes">
                    <p>{{ voo.Duracao.substring(0, 5) }}</p>
                    <app-trecho-simbol></app-trecho-simbol>
                  </div>
                </div>
                <div class="col">
                  <p>{{ voo.AeroportoChegada }}</p>
                  <h6>{{ voo.DataChegada | date: "dd/MM/yyyy HH:mm" }}</h6>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  {{"Voo" | translate}} N°{{ voo.NumeroVoo }} | {{"Classe" | translate}}: {{voo.ClasseTarifaria}} |
                  {{"Bagagem" | translate}}:
                  {{ seguimento.BagagemQuantidade }}
                </div>
              </div>
            </div>
          </div>
          <div class="col" *ngIf="i % 2 != 0">
            <div class="row jc-sb">
              <div class="col subtitle">
                <h6><i class="fas fa-plane-arrival"></i>{{"Volta" | translate}}</h6>
              </div>
            </div>

            <div *ngFor="let voo of seguimento.Voos; let k = index">
              <div class="row jc-se">
                <div class="col as-c">
                  <img src="assets/img/cias/{{ voo.CiaMarketing }}.png" alt="{{ voo.CiaMarketing }}"
                    title="{{ voo.CiaMarketing }}" />
                </div>
                <div class="col">
                  <p *ngIf="k == 0 || (k > 0 && voo.AeroportoPartida == seguimento.Voos[k - 1].AeroportoChegada)">{{
                    voo.AeroportoPartida }}</p>
                  <p *ngIf="k > 0 && voo.AeroportoPartida != seguimento.Voos[k - 1].AeroportoChegada" style="color:red">
                    {{
                    voo.AeroportoPartida }}*</p>
                  <h6>{{ voo.DataPartida | date : 'dd/MM/yyyy HH:mm'}}</h6>
                </div>
                <div class="col text-center">
                  <div class="col voo-detalhes">
                    <p>{{ voo.Duracao.substring(0, 5) }}</p>
                    <app-trecho-simbol></app-trecho-simbol>
                  </div>
                </div>
                <div class="col">
                  <p>{{ voo.AeroportoChegada }}</p>
                  <h6>{{ voo.DataChegada | date: "dd/MM/yyyy HH:mm" }}</h6>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  {{"Voo" | translate}} N°{{ voo.NumeroVoo }} | {{"Classe" | translate}}: {{voo.ClasseTarifaria}} |
                  {{"Bagagem" | translate}}:
                  {{ seguimento.BagagemQuantidade }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class='col-2 as-c'>
        <div class='row text-center' *ngIf="user.EmpresaId != undefined && user.EmpresaId !== null">
          <div class='col mb-3 as-c'>
            <h6>{{"Fornecedor" | translate}}</h6>
            <img src="assets/img/cias/{{ aereo?.Fornecedor }}.png" alt="{{ aereo?.Fornecedor }}"
              title="{{ aereo?.Fornecedor }}" />
          </div>

        </div>
        <div class="row text-center">
          <div class="col">
            <p class="subtitle">{{"Total" | translate}}</p>
            <h5> {{aereo?.MoedaListagem?.Simbolo}} {{aereo?.TarifasListagemTotal | currency:'BRL':'':'2.2-2' }}</h5>
            <p>+ {{'Taxas' | translate}}: {{aereo?.MoedaListagem?.Simbolo}} {{aereo?.TaxasListagemTotal |
              currency:'BRL':'':'2.2-2'}}</p>
            <p>+ {{'RC' | translate}}: {{aereo?.MoedaListagem?.Simbolo}} {{aereo?.TaxasDUListagemTotal |
              currency:'BRL':'':'2.2-2'}}</p>
          </div>
        </div>
      </div>
    </div>

  </div>

  <div *ngIf="aereo?.Erros?.length > 0 && dentroDoOrcamento" class="row d-flex justify-content-center">
    <ul>
      <li *ngFor="let m of aereo.Erros">
        <strong style="color: red;">{{m}}</strong>
      </li>
    </ul>
  </div>

  <div *ngIf="aereo?.PaxesTarifa?.length > 0 && dentroDoOrcamento" class="row d-flex justify-content-center">
    <div class="table">
      <table class="table-responsive w-100">
        <tr style="font-weight: 500; text-align: center; ">
          <td>{{"Tipo" | translate}}</td>
          <td>{{"Qntd" | translate}}</td>
          <td>{{"Tarifa(un)" | translate}}</td>
          <td>{{"Taxas de serviço(un)" | translate}}</td>
          <td>{{"Taxas" | translate}}</td>
          <td *ngIf="temRC(aereo.PaxesTarifa)">RC(un)</td>
          <td>{{"Valor por" | translate}} PAX</td>
          <td>{{"Subtotal" | translate}}</td>
        </tr>
        <tr *ngFor="let tarifa of aereo.PaxesTarifa" class="text-center">
          <td>{{(tarifa.TipoPax == 0 ? 'ADT' : (tarifa.TipoPax == 1 ? 'CHD' : 'INF')) | translate}}
          </td>
          <td>{{tarifa.QtdPax}}</td>
          <td>{{aereo.MoedaListagem?.Sigla}} {{tarifa.ValorTarifaListagem | currency:'BRL':'':'1.2-2' }}
          </td>
          <td>{{aereo.MoedaListagem?.Sigla}}
            {{tarifa.ValorTaxaServicoListagem | currency:'BRL':'':'1.2-2' }}
          </td>
          <td>{{aereo.MoedaListagem?.Sigla}} {{tarifa.ValorTaxaListagem | currency:'BRL':'':'1.2-2' }}
          </td>
          <td *ngIf="temRC(aereo.PaxesTarifa)">{{aereo.MoedaListagem?.Sigla}}
            {{tarifa.ValorTaxaDUListagem | currency:'BRL':'':'1.2-2' }}
          </td>
          <td>{{aereo.MoedaListagem?.Sigla}}
            {{tarifa.ValorTarifaListagem + tarifa.TotalTaxasListagem + tarifa.ValorTaxaDUListagem |
            currency:'BRL':'':'1.2-2' }}
          </td>
          <td>{{aereo.MoedaListagem?.Sigla}} {{tarifa.SubTotalListagem | currency:'BRL':'':'1.2-2' }}
          </td>
        </tr>
      </table>
    </div>
  </div>

  <div class="row" style="padding: 0px 15px" *ngIf="dentroDoOrcamento">
    <div class="col-md-8" style="align-self: flex-end;">
      <strong>{{'Data Inclusão' | translate}}:</strong>
      {{aereo?.Alteracoes?.CriadoEm | date:'dd/MM/yyyy HH:mm:ss'}}
      <strong *ngIf="aereo?.Status != 5">{{'Data Limite' | translate}}:</strong>
      {{aereo?.LimiteTempoEmissao | date :'dd/MM/yyyy HH:mm:ss'}}
      <p *ngIf="aereo?.PrazoCancelamentoWs != null"><strong>{{'Prazo de Cancelamento' | translate}}:</strong>
        {{aereo.PrazoCancelamentoWs | date:'dd/MM/yyyy HH:mm:ss'}}
      </p>
    </div>
    <!-- <div class="col-md-4 text-right" style="padding-right:40px">
                              <strong class="texto-Preco">{{aereo.MoedaListagem.Sigla}}
                                {{aereo.ValorListagem | currency:'BRL':'':'2.2-2'}}</strong><br>
                              <p style="font-size: 13px;">({{aereo.MoedaListagem.Sigla}}
                                {{aereo.TaxasListagemTotal | currency:'BRL':'':'2.2-2'}} de taxas)
                              </p>
                            </div> -->
  </div>

  <div class="row" *ngIf="mensagensErroAereo.length > 0">
    <div class="col">
      <ul>
        <li>
          <strong style="color: red;">{{mensagensErroAereo}}</strong>
        </li>
      </ul>
    </div>
  </div>
</ng-container>

<!-- Templates do conteúdo de cada modal -->
<ng-template #tplReserva>
  <app-aereo-reserva [aereo]="aereo" (alterou)="atualizarAereo($event)"
    (fechou)="modalReserva.close()"></app-aereo-reserva>
</ng-template>
<ng-template #tplEmitirAereo>
  <app-aereo-emite [aereo]="aereo" (alterou)="atualizarAereo($event)"
    (fechou)="modalEmitirAereo.close()"></app-aereo-emite>
</ng-template>
<ng-template #tplCancelarAereo>
  <app-aereo-cancela [aereo]="aereo" (alterou)="atualizarAereo($event)"
    (fechou)="modalCancelarAereo.close()"></app-aereo-cancela>
</ng-template>

<!-- Modais agora recebem o template como input -->
<app-modal *ngIf="dentroDoOrcamento" #modalReserva
  [modalConfig]="{ modalTitle: 'Reserva de aéreo' | translate, hideCloseButton: true, hideDismissButton: true }"
  [template]="tplReserva">
</app-modal>

<app-modal *ngIf="dentroDoOrcamento" #modalEmitirAereo
  [modalConfig]="{ modalTitle: 'Emissão de aéreo' | translate, hideCloseButton: true, hideDismissButton: true }"
  [template]="tplEmitirAereo">
</app-modal>

<app-modal *ngIf="dentroDoOrcamento" #modalCancelarAereo
  [modalConfig]="{ modalTitle: 'Cancelamento de aéreo' | translate, hideCloseButton: true, hideDismissButton: true }"
  [template]="tplCancelarAereo">
</app-modal>


<div class="overlay d-flex justify-content-center" *ngIf="carregando">
  <img src="assets/img/loading1.gif" alt="Loading..." />
</div>
